import React from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import UserAvatar from '../../components/UserAvatar'
import FgCompanyLogo from '../../components/clients/FgCompanyLogo'
import './dashboard.less'

@connect(state => ({
    user: state.auth.user,
    recentlyViewedClients: state.entitySearch.recentlyViewedClients,
}))
export default class Dashboard extends React.Component {
    render() {
        const { user, recentlyViewedClients } = this.props

        return (
            <div className="dashboard">
                <div className="personalKpi">
                    <div className="personalKpi__summary container--blue hasShadow">
                        <div className="personalKpi__user">
                            <UserAvatar user={user} size="62" />

                            <div className="personalKpi__spacer--vertical"></div>

                            <div className="personalKpi__user__text">
                                <b>Welcome, {user.firstName}</b>
                            </div>
                        </div>
                    </div>
                    {recentlyViewedClients.length > 0 && (
                        <div className="recently-viewed">
                            <h1>Recently Viewed Companies</h1>
                            <div className="lead-items">
                                {recentlyViewedClients.map(c => (
                                    <ClientCard
                                        onSelectClient={
                                            this.props.onSelectClient
                                        }
                                        client={c}
                                        key={c.id}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const ClientCard = ({ client, key }) => (
    <Link
        className="lead-card"
        key={key}
        to={`/clients/${client.id}`}
    >
        <div className="lead-card__logo">
            <FgCompanyLogo fergusId={client.fergusId} />
        </div>
        <div className="lead-card__content">
            <h1>{client.entityName}</h1>
            <h2>{client.shortAddress}</h2>
        </div>
    </Link>
)



// WEBPACK FOOTER //
// ./app/pages/dashboard/Dashboard.js